import React from 'react'
import { useTranslation } from 'react-i18next'
import { Typography } from '@mui/material'
import { useNavigate, useParams } from 'react-router-dom'
import { OPERATION_FIND_CONTACT } from 'pages/Contacts/operations-gql/queries'
import { useMutation, useQuery } from '@apollo/client'
import {
  OPERATION_DISABLE_CONTACT,
  OPERATION_REACTIVATE_CONTACT,
} from 'pages/Contacts/operations-gql/mutations'
import ActionModal from 'components/Modal/ActionModal'
import { trackEvent } from 'analytics'

const DisableUser = () => {
  const { sfId } = useParams()
  const { t } = useTranslation()
  const navigate = useNavigate()

  const handleClose = () => {
    navigate({ pathname: '..' })
  }
  
  const { data } = useQuery(OPERATION_FIND_CONTACT, {
    variables: {
      sf_id: sfId,
      with_accounts: false
    },
  })

  const [reactivateContact, { loading: reactivating }] = useMutation(OPERATION_REACTIVATE_CONTACT, {
    refetchQueries: [
      'GetContacts',
      'GetContact'
    ]
  })

  const [disableContact, { loading: disabling }] = useMutation(OPERATION_DISABLE_CONTACT, {
    refetchQueries: [
      'GetContacts',
      'GetContact'
    ]
  })

  const contactState = data?.contact?.state
  const isDeactivation = contactState !== 'deactivated'

  const handleConfirm = async () => {
    const mutation = isDeactivation ? disableContact : reactivateContact
    await mutation({
      variables: {
        sf_id: sfId,
      },
    })
    trackEvent(isDeactivation ? 'user_deactivated' : 'user_activated')
    handleClose()
  }

  return (
    <ActionModal
      cancelLabel={t('ui_elements.cancel')}
      confirmLabel={
        isDeactivation
          ? t('coupons.actions.deactivate_user.modal_button')
          : t('coupons.actions.reactivate_user.modal_button')
      }
      description={(
        <Typography
          component="span"
          sx={{ fontSize: 13, textAlign: 'center' }}
          dangerouslySetInnerHTML={{
            __html: isDeactivation
              ? t('coupons.actions.deactivate_user.modal_message')
              : t('coupons.actions.reactivate_user.modal_message')
          }}
        />
      )}
      icon={<i className={`fa-light fa-${isDeactivation ? 'pause' : 'play'}`} />}
      loading={disabling || reactivating}
      onClose={handleClose}
      onConfirm={handleConfirm}
      title={
        isDeactivation
          ? t('coupons.actions.deactivate_user.modal_title_message')
          : t('coupons.actions.reactivate_user.modal_title_message')
      }
      variant={isDeactivation ? 'error' : 'success'}
    />
  )
}

export default DisableUser